const baseStyle = {
  maxW: '7xl',
  px: { base: '4', md: '8' },
}

export default { baseStyle }
